<template>
  <div class="sys-parameter-container">
    <Card>
      <p slot="title">系统参数设置</p>

      <div class="search-con">
        <Input
          v-model="searchParams.key"
          placeholder="请输入参数名称或含义"
          style="width: 300px; margin-right: 10px"
          clearable
          @on-enter="handleSearch"
        >
          <span slot="prepend">搜索</span>
        </Input>

        <Input
          v-model="searchParams.tables"
          placeholder="请输入表名"
          style="width: 200px; margin-right: 10px"
          clearable
        >
          <span slot="prepend">表名</span>
        </Input>

        <Button type="primary" @click="handleSearch">搜索</Button>
        <Button type="success" @click="handleAdd" style="margin-left: 10px">新增参数</Button>
      </div>

      <div style="margin-top: 20px">
        <Table
          :columns="columns"
          :data="tableData"
          :loading="loading"
          border
          stripe
          @on-sort-change="handleSortChange"
        >
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" size="small" @click="handleEdit(row)">编辑</Button>
            <Button
              type="warning"
              size="small"
              style="margin-left: 10px"
              @click="handleStatus(row)"
            >
              {{ row.flag === 0 ? '禁用' : '启用' }}
            </Button>
            <Button
              type="error"
              size="small"
              style="margin-left: 10px"
              @click="handleDelete(row)"
            >
              删除
            </Button>
          </template>

          <template slot-scope="{ row }" slot="flag">
            <Tag :type="row.flag === 0 ? 'success' : 'error'">
              {{ row.flag === 0 ? '启用' : '禁用' }}
            </Tag>
          </template>

          <template slot-scope="{ row }" slot="sys_or_user">
            <Tag :type="row.sys_or_user === 1 ? 'success' : 'warning'">
              {{ row.sys_or_user === 1 ? '系统级' : '用户级' }}
            </Tag>
          </template>

          <template slot-scope="{ row }" slot="isopen">
            <Tag :type="row.isopen === 0 ? 'success' : 'warning'">
              {{ row.isopen === 0 ? '公开' : '不公开' }}
            </Tag>
          </template>
        </Table>

        <div style="margin-top: 20px; text-align: right">
          <Page
            :total="total"
            :current="pageParams.page"
            :page-size="pageParams.limit"
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
            show-sizer
            show-total
          />
        </div>
      </div>
    </Card>

    <!-- 新增/编辑弹窗 -->
    <Modal
      v-model="modalVisible"
      :title="modalTitle"
      width="600px"
      @on-ok="handleSubmit"
      @on-cancel="modalVisible = false"
    >
      <Form ref="paramForm" :model="formData" :rules="formRules">
        <FormItem label="参数名称" prop="field">
          <Input v-model="formData.field" placeholder="请输入参数名称" />
        </FormItem>

        <FormItem label="参数值" prop="value">
          <Input v-model="formData.value" placeholder="请输入参数值" />
        </FormItem>

        <FormItem label="参数含义" prop="meaning">
          <Input v-model="formData.meaning" placeholder="请输入参数含义" />
        </FormItem>

        <FormItem label="所属表" prop="table">
          <Input v-model="formData.table" placeholder="请输入所属表名" />
        </FormItem>

        <FormItem label="备注" prop="remark">
          <Input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </FormItem>

        <FormItem label="创建等级" prop="sys_or_user">
          <Select v-model="formData.sys_or_user">
            <Option value="1">系统级</Option>
            <Option value="2">用户级</Option>
          </Select>
        </FormItem>

        <FormItem label="是否公开" prop="isopen">
          <Select v-model="formData.isopen">
            <Option value="0">公开</Option>
            <Option value="1">不公开</Option>
          </Select>
        </FormItem>

        <FormItem label="状态" prop="flag">
          <Select v-model="formData.flag">
            <Option value="0">启用</Option>
            <Option value="1">禁用</Option>
          </Select>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button @click="modalVisible = false">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getsysparameterList, operationsysparameter } from '@/api/system/sys_parameter'

export default {
  name: 'SysParameter',
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,

      searchParams: {
        key: '',
        tables: ''
      },

      pageParams: {
        page: 1,
        limit: 10
      },

      modalVisible: false,
      modalTitle: '',
      formData: {
        id: null,
        table: '',
        field: '',
        value: '',
        meaning: '',
        flag: 0,
        remark: '',
        backup: '',
        sys_or_user: 2,
        createrid: null,
        isopen: 0
      },

      formRules: {
        field: [
          { required: true, message: '请输入参数名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入参数值', trigger: 'blur' },
          { max: 100, message: '长度不能超过 100 个字符', trigger: 'blur' }
        ],
        meaning: [
          { required: true, message: '请输入参数含义', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        table: [
          { max: 100, message: '长度不能超过 100 个字符', trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' }
        ]
      },

      columns: [
        { title: 'ID', key: 'id', width: 80, sortable: true },
        { title: '表名', key: 'table', width: 150 },
        { title: '参数名称', key: 'field', width: 180, sortable: true },
        { title: '参数值', key: 'value', width: 150 },
        { title: '参数含义', key: 'meaning', width: 180 },
        { title: '创建等级', slot: 'sys_or_user', width: 100 },
        { title: '是否公开', slot: 'isopen', width: 100 },
        { title: '状态', slot: 'flag', width: 100 },
        { title: '更新时间', key: 'update_time', width: 180, sortable: true },
        { title: '操作', slot: 'action', width: 250, fixed: 'right' }
      ]
    }
  },

  mounted () {
    this.getParamList()
  },

  methods: {
    async getParamList () {
      this.loading = true
      try {
        const res = await getsysparameterList(
          this.searchParams.key,
          '',
          '',
          this.pageParams.page,
          this.pageParams.limit,
          this.searchParams.tables
        )

        if (res.data.code === 0) {
          this.tableData = res.data.data || []
          this.total = res.data.count || 0
        } else {
          this.$Message.error(res.data.msg || '获取参数列表失败')
        }
      } catch (error) {
        this.$Message.error('获取参数列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.pageParams.page = 1
      this.getParamList()
    },

    handleSortChange ({ column, key, order }) {
      // 排序功能实现
      console.log('排序:', column, key, order)
    },

    handlePageChange (page) {
      this.pageParams.page = page
      this.getParamList()
    },

    handlePageSizeChange (pageSize) {
      this.pageParams.limit = pageSize
      this.pageParams.page = 1
      this.getParamList()
    },

    handleAdd () {
      this.modalTitle = '新增参数'
      this.formData = {
        id: null,
        table: '',
        field: '',
        value: '',
        meaning: '',
        flag: 0,
        remark: '',
        backup: '',
        sys_or_user: 2,
        createrid: null,
        isopen: 0
      }
      this.modalVisible = true
    },

    handleEdit (row) {
      this.modalTitle = '编辑参数'
      this.formData = { ...row }
      this.modalVisible = true
    },

    handleStatus (row) {
      this.$Modal.confirm({
        title: '确认操作',
        content: `确定要${row.flag === 0 ? '禁用' : '启用'}该参数吗？`,
        onOk: async () => {
          try {
            const res = await operationsysparameter({
              ...row,
              flag: row.flag === 0 ? 1 : 0
            }, 'post')

            if (res.data.code === 0) {
              this.$Message.success('操作成功')
              this.getParamList()
            } else {
              this.$Message.error(res.data.msg || '操作失败')
            }
          } catch (error) {
            this.$Message.error('操作失败')
            console.error(error)
          }
        }
      })
    },

    handleDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定要删除该参数吗？',
        onOk: async () => {
          try {
            const res = await operationsysparameter({ id: row.id }, 'delete')

            if (res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getParamList()
            } else {
              this.$Message.error(res.data.msg || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败')
            console.error(error)
          }
        }
      })
    },

    async handleSubmit () {
      try {
        this.$refs.paramForm.validate(async (valid) => {
          if (valid) {
            let res
            if (this.formData.id) {
              res = await operationsysparameter(this.formData, 'post')
            } else {
              res = await operationsysparameter(this.formData, 'post')
            }

            if (res.data.code === 0) {
              this.$Message.success(this.formData.id ? '更新成功' : '新增成功')
              this.modalVisible = false
              this.getParamList()
            } else {
              this.$Message.error(res.data.msg || '操作失败')
            }
          }
        })
      } catch (error) {
        this.$Message.error('操作失败')
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.sys-parameter-container {
  padding: 10px;
}

.search-con {
  display: flex;
  align-items: center;
}
</style>
